import { render, staticRenderFns } from "./ScreenOptions.vue?vue&type=template&id=d97f3ce8"
import script from "./ScreenOptions.vue?vue&type=script&lang=js"
export * from "./ScreenOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports